import Alpine from 'alpinejs'

Alpine.store('menuVisible', false)
Alpine.store('infoMenuVisible', false)

Alpine.data('handleMenus', (element, storeKey) => {
  element.querySelectorAll('.menu-item').forEach(menuItem => {
    let menuLink = menuItem.querySelector('a')

    menuLink.setAttribute(':role', `$store.${storeKey} ? null : "presentation"`)
    menuLink.setAttribute(':tabindex', `$store.${storeKey} ? 0 : -1`)
    menuItem.setAttribute(':aria-hidden', `$store.${storeKey} ? "false" : "true"`)
    menuItem.setAttribute(
      'x-on:click',
      `(event) => {
      if (!$store.${storeKey}) {
        event.preventDefault()
        $store.${storeKey} = true
      }
    }`,
    )

    let href = menuLink.getAttribute('href')
    menuLink.setAttribute(':href', `$store.${storeKey} ? ${JSON.stringify(href)} : null`)
  })
})

if (!CSS.supports('selector(:has(*))')) {
  document.querySelectorAll('nav.info .sub-menu .current-menu-item').forEach(menuItem => {
    menuItem.closest('.current-menu-ancestor').classList.add('has-current-children')
  })
}
